import React from "react";
import "../../pages/style.css";
import { Container, Row, Col } from "react-bootstrap";

const Aboutpage = () => {
  return (
    <div className="aboutpagebackground">
      <Container>
        <Row className="textbackground">
          <Col md={7}>
            <h1 className="aboutmetext">
              <span>About Me</span>
            </h1>
            <hr />
            <p className="aboutdetails">
              As a dedicated Front End developer hailing from India, my journey
              has been driven by a relentless pursuit of excellence. User
              experience and responsiveness are at the core of my craft,
              allowing me to create websites that cater to a diverse audience.
              My true passion lies in crafting scalable distribution systems and
              unraveling intricate challenges. A deep-rooted belief in the
              significance of writing clean and maintainable code fuels my
              commitment to ensuring long-term sustainability. By incorporating
              responsive design principles, I strive to democratize website
              accessibility across all devices. Continuously seeking growth, I
              eagerly embrace opportunities to expand my knowledge and skills
              while leaving a lasting impact on meaningful projects.
            </p>
            <ul className="skilllist">
              <Row>
                <h3>
                  <b>Skills:-</b>
                </h3>
                <Col md={6}>
                  <li>React Js</li>
                  <li>Redux</li>
                  <li>JavaScript</li>
                  <li>TailwindCSS</li>
                  <li>React-Bootsrap</li>
                  <li>Postman</li>
                </Col>
                <Col md={5}>
                  <li>HTML5</li>
                  <li>CSS3</li>
                  <li>Bootsrap-5</li>
                  <li>Git/Github</li>
                  <li>Rest-Api</li>
                  <li>Firebase</li>
                </Col>
              </Row>
            </ul>
          </Col>
          <Col md={5}>
            <div className="webimage"></div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Aboutpage;
